<template>
    <div>
        <el-dialog
            title="添加导师"
            :visible.sync="showdialog"
            width="800px"
            @close="back">
            <div class="base-warp">
                <el-form :model="form" label-width="80px" :inline="false" size="mini">
                    <el-form-item label="头像">
                        <el-upload
                            class="avatar-uploader"
                            action="/api/Upload/uploadFile/"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input v-model="form.name" placeholder="导师的真实姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="关联用户">
                        <div class="flex-box">
                            <el-input v-model="form.uname" placeholder="请点击右侧按钮选择用户" disabled></el-input>
                            <member-list @getMember="getMember"></member-list>
                        </div>
                    </el-form-item>
                    <el-form-item label="康旅顾问"  >
                        <el-switch   v-model="form.is_kl" active-text="是" inactive-text="否"></el-switch>
                    </el-form-item>
                    <el-form-item label="简介">
                        <el-input type="textarea" v-model="form.intro" placeholder="这里填写导师的简介"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="confirm">保存</el-button>
                        <el-button @click="showdialog = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MemberList from '../../../components/member-list.vue'
export default {
    components: {
        MemberList,
    },
    data() {
        return {
            showdialog: true,
            form: {
                name: '',
                intro: '',
                uname: '',
                uid: '',
                is_kl:false,
            },
            imageUrl: '',
        }
    },
    methods: {
        confirm() {
            if (!this.form.uid){
                this.$confirm('关联的用户没选')
                return;
            }
            var params = {
                name: this.form.name,
                ltpic: this.imageUrl,
                intro: this.form.intro,
                uid: this.form.uid,
                is_kl: this.form.is_kl,
            }
            this.$api.addTutor(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        },
        back() {
            this.$router.go(-1);
        },
        getMember(e) {
            this.form.uname = e.uname;
            this.form.uid = e.mid;
        },
        handleAvatarSuccess(response) {
            let {data, msg} = response;
            if (data){
                this.$message.success(msg);
                this.imageUrl = data;
                this.$forceUpdate()
            } else {
                this.$message.error(msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
::v-deep .el-textarea__inner{
    height: 200px;
}
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>